import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsIcon } from 'lucide-react';
export function UniqueMethod() {
  return <section className="bg-[#2D6A4F] py-24 px-6 relative overflow-hidden" data-id="element-177">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-178">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-179"></div>
        <div className="absolute bottom-0 left-10 w-64 h-64 bg-[#E76F51] rounded-full blur-3xl" data-id="element-180"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center p-4 bg-white/10 rounded-2xl backdrop-blur-sm mb-8" data-id="element-182">
          <UtensilsIcon size={40} className="text-[#FFF8F0]" data-id="element-183" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-heading text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-184">
          El Método del Ensamblaje Estratégico
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-white/5 border border-white/10 p-8 md:p-10 rounded-3xl backdrop-blur-md" data-id="element-185">
          <p className="text-[#FFF8F0] text-xl md:text-2xl leading-relaxed font-light" data-id="element-186">
            Este no es un libro de cocina; es un{' '}
            <strong className="font-bold text-white" data-id="element-187">
              manual de operaciones logísticas
            </strong>
            . En lugar de cocinar, aprenderás a "ensamblar" componentes
            nutricionales de alta calidad que ya vienen listos en tu
            supermercado local.
          </p>
          <p className="text-[#FFF8F0] text-lg md:text-xl leading-relaxed mt-6 font-light" data-id="element-188">
            Usando la{' '}
            <span className="bg-[#E76F51] text-white px-3 py-1 rounded-lg font-semibold mx-1" data-id="element-189">
              Matriz 3-2-1
            </span>
            , garantizas proteína, energía y vitaminas en cada recipiente sin
            tener que usar la estufa ni una sola vez al amanecer.
          </p>
        </motion.div>
      </div>
    </section>;
}